<template>
  <div class="appBody">
     <div class="createdTitle-body">
       <img src="../../assets/image/screenImg/huanjing.png" alt="" class="leftTopIcon">
   <p class="createdTitle">环境管理</p>

   <screenNavigation class="screenNavigation" :name='createdName' ref="leftclick" v-clickoutside="handleClickOutside" :topClass='topClass'></screenNavigation>
   </div>
    <!-- <div style="height: 200px; background: red"></div> -->
    <div class="leftBody">
      <div class="left-top">
        <div class="left-top-title">
          <p>岗位人员出勤</p>
          
        </div>
        <!-- 头部盒子下方的线条 -->
<div class='border-Max'>
<div class='border-left'>
</div>
<div class='border-center'>
</div>
<div class='border-right'>
</div>
</div>
        <div class="left-top-body" style="z-index:9999">
          <div class="personnelTitle">
            <div      v-for="(item) in personnelTitleList" :key="item.id"
            style=" cursor:pointer;"
              class="personnelTitle-txt"
              :class="{ titleClick:  clickIndex==item.id  }"
              @click="personnelTitleFun(item.id)">
            <p
            
            >
              {{ item.name }}
            </p>
</div>
   
          </div>
          <div class="personnelCenter">
            <div class="shuju">

             <p class="centerNum">{{personnelData.count}}</p>
            <p class="centerNumTxt">当日出勤</p>
            </div>
           
<img src="../../assets/image/screenImg/jx.png" alt="" class="centerImg">
          </div>
          <div class="personnel-right">
            <p class="allTeamsCount">登记总人数</p>
            <img src="../../assets/image/screenImg/yuana.png" alt="" class="c-img">
            <p class="num-Top">{{personnelData.all}}</p>
            <p class="allTeamsCount">实时在场人数</p>
                 <img src="../../assets/image/screenImg/yuanb.png" alt="" class="c-img">
            <p class="num-Bottom">{{personnelData.zcCount}}</p>
          </div>
        </div>
        <div class="left-body-bottom">
   <div class="left-top-title">
          <p>劳务公司统计</p>
        </div>
        <!-- 头部盒子下方的线条 -->
<div class='border-Max'>
<div class='border-left'>
</div>
<div class='border-center'>
</div>
<div class='border-right'>
</div>
</div>
            <div class="left-top-body left-bottom-body"></div>
        </div>
      </div>
    </div>
    <div class="centerBody">
      <div class="center-top">
        <div class="center-top-title">
   <p>出勤人数统计</p>
        </div>
        <div class='border-center-Max'>
<div class='border-center-left'>
</div>
<div class='border-center-center'>
</div>
<div class='border-center-right'>
</div>
</div>
        <div class="center-top-body">
           <div class="center-top-body-A"></div>
        </div>
      </div>
         <div class="center-bottom">
        <div class="center-top-title">
          <p>单位人员出勤统计</p>
        </div>
        <div class='border-center-Max'>
<div class='border-center-left'>
</div>
<div class='border-center-center'>
</div>
<div class='border-center-right'>
</div>
</div>
        <div class="listTitle">
          <p class="title-a">参建单位</p>
             <p class="title-b">登记人数</p>
                <p class="title-c">出勤人数</p>
                   <p class="title-d">实时人数</p>
        </div>
         <div class="center-top-body"  style="padding-top:.625vw;overflow: hidden;height:15vw">
         
   <div class="lfet-top-list"  :class="{ animb: animate3 }" style=" height:118%;width:100%;">
            <div class="center-list-body" v-for="(item,index) in companyAttendance" :key="index">
<div class="list-body-title">{{item.entName}}</div>
<div class="list-body-A">{{item.sumNumber}}</div>
<div class="list-body-B">{{item.entranceCount}}</div>
<div class="list-body-C">{{item.realTimeNumber}}</div>
            </div>
    
          </div>
       
         </div>
      </div>
<!--       
            <div class="center-bottom">
        <div class="center-top-title">
   <p>单位人员出勤统计</p>
        </div>
        <div class="center-top-body">
         
        </div>
      </div> -->
    </div>
    <div class="rightBody">
      <div class="left-top" style="margin-bottom: 2.8125vw;">
        <div class="left-top-title">
          <p>进出场记录</p>
        </div>
        <!-- 头部盒子下方的线条 -->
<div class='border-Max'>
<div class='border-left'>
</div>
<div class='border-center'>
</div>
<div class='border-right'>
</div>
</div>
         <div class="left-top-body left-bottom-body"  style="padding-top:.625vw;overflow: hidden;">
         
   <div class="lfet-top-list"  :class="{ anim: animate2 == true }" style=" height:118%;width:100%;">
            <div class="lfet-top-list-body" v-for="(item,index) in punchingCardList" :key="index">
<img :src="httpCtx+item.photoFile" alt="" class="punchingCardImg" v-show="item.photoFile">
<div  class="punchingCardName">
<p>{{item.name1}}</p>
</div>
<div class="gangwei">
  <p class="gangwei">{{item.teamsName}}</p>
</div>
<p ><span v-if="item.status==0">进闸时间</span> <span v-if="item.status==1">出闸时间</span>{{item.clockTime}}</p>
            </div>
    
          </div>
       
         </div>
      </div>
            <div class="left-top">
        <div class="left-top-title">
          <p>人员年龄分布</p>
        </div>
        <!-- 头部盒子下方的线条 -->
<div class='border-Max'>
<div class='border-left'>
</div>
<div class='border-center'>
</div>
<div class='border-right'>
</div>
</div>
        <div class="left-top-body rightBottomEcah">
         
     
        </div>
    
      </div>
    </div>
  </div>
</template>

<script>
  import screenNavigation from './screenNavigation.vue'
import Clickoutside from 'element-ui/src/utils/clickoutside'
import myHttp from '../../untils/port'
  import util from '../../untils/util'
  import screenHttp from '../../untils/screenHttp'
  import base from '../../untils/base'
export default {
  directives: { Clickoutside },
  data() {

    return {
      topClass:3,
      createdName:'劳务管理',
      echaData:[],
      selectEntCountList:[],
      companyAttendance:[],//单位人员出勤
      httpCtx:base.httpCtx,
      punchingCardList:[],//打卡信息
      personnelData:{all:'',count:'',zcCount:''},
      manage:{all:'',count:'',zcCount:''},
      special:{all:'',count:'',zcCount:''},
      workers:{all:'',count:'',zcCount:''},
      personnelAll:{all:'',count:'',zcCount:''},
  
      keyPosition:[1,2,3,4,5,6,7,8,89,9,9,9,9,],
      animate2:false,
      animate3:false,
       projectId: util.session.get('groupId'),
      clickIndex:99,
      personnelTitleList: [{name:'全部人员',id:99}, {name:'管理人员',id:98},{name:'建筑工人',id:97},{name:'特种人员',id:96},],
      personnel:{},
    }
  },
  created() {
   
   this.dayAttendance()//获取出勤信息
   this.dayInAttendance()//获取在场信息
   this.punchingCardRecord()//获取打卡记录
   this.selectDayEntCount()//获取单位人员出勤统计
   this.selectEntCount()//单位占比
  this.ageDistribution()//人员年龄分部
 
  },
  components:{screenNavigation},
  methods: {
       handleClickOutside(){
      this.$refs.leftclick.listShow=false
    },
    scroll2(){
    if (this.punchingCardList.length > 5) {
      // console.log('123');
        this.animate2 = true;
        setTimeout(() => {
          this.punchingCardList.push(this.punchingCardList[0]);
          this.punchingCardList.shift();
          this.animate2 = false;
        }, 1200)
      } 
    },
      scroll3(){
    if (this.companyAttendance.length > 7) {
      // console.log('123');
        this.animate3 = true;
        setTimeout(() => {
          this.companyAttendance.push(this.companyAttendance[0]);
          this.companyAttendance.shift();
          this.animate3 = false;
        }, 1200)
      } 
    },
    personnelTitleFun(index){
         this.clickIndex=index
         if(index==99){
          // 全部人员
          this.personnelData=this.personnelAll
         }else if(index==98){
          // 管理人员
           this.personnelData=this.manage
         }else if(index==97){
          // 工人
             this.personnelData=this.workers
         }else if(index==96){
          // 特种
                   this.personnelData=this.special
         }
      console.log(index);
      console.log( this.clickIndex);
      console.log(1);
   
    },

    // 获取出勤人员信息
   async dayAttendance(){
const data=await myHttp.dayAttendance({
projectId:this.projectId
})
if(data.data.code==200){
  console.log('出勤人员信息==》',data);
  this.personnel=data.data.data

    //管理人员
    this.manage.all= this.personnel.manageAll,
    this.manage.count=this.personnel.manageCount

      //特殊人员
    this.special.all= this.personnel.specialAll,
   this.special.count=this.personnel.specialCount
  //工人
    this.workers.all= this.personnel.workersAll,
    this.workers.count=this.personnel.workersCount
    // 所有
    this.personnelAll.all=this.personnel.allTeamsCount
        this.personnelAll.count=this.personnel.allNowCount
          this.personnelData=this.personnelAll
  console.log('管理人员',this.manage);
    console.log('特殊人员',this.special);
      console.log('工人',this.workers);

this.echb()
}

    },
    // 获取在场人员
    async dayInAttendance(){
    const data = await myHttp.dayInAttendance({projectId:this.projectId
    })
    if(data.data.code==200){
      console.log('在场数据----》',data);
      let res=data.data.data
      this.personnelAll.zcCount=res.allNowCount
         this.manage.zcCount=res.manageCount
              this.special.zcCount=res.specialCount
                      this.workers.zcCount=res.workersCount
                      console.log(this.personnelAll.zcCount,this.manage.zcCount,this.special.zcCount,this.workers.zcCount);
         
      
    }
    },
    // 获取打卡记录
   async punchingCardRecord(){
const data= await screenHttp.punchingCardRecord({ projectId: this.projectId})
if(data.data.code==200){
  console.log('打卡记录----->',data);
  this.punchingCardList=data.data.data
  console.log('打卡信息----》',this.punchingCardList);
   setInterval(this.scroll2, 2000)
}
    },
    // 获取公司占比
  async selectEntCount(){
const data= await screenHttp.selectEntCount({
  projectId:this.projectId
})

if(data.data.code==200){
  console.log('公司占比信息----》',data);
  this.selectEntCountList=data.data.data
  console.log('占比信息数组-----》',this.selectEntCountList);
  let nameList=[]
  let colorList=[]
  this.selectEntCountList.forEach((item,index) => {
    if(item.name.length>7){
      item.name=item.name.slice(0,6)+'...' 
    }
  nameList.push( item.name)
           var hex = Math.floor(Math.random() * 16777216).toString(16);
            //生成ffffff以内16进制数 
            while (hex.length < 6) {
                //while循环判断hex位数，少于6位前面加0凑够6位
                hex = '0' + hex;
            }
colorList.push('#'+hex)
  });
  console.log(nameList,colorList);
  let objArry=[]
  nameList.forEach((item,index) => {
    let obj ={name:'',
                value:''}
                obj.name=nameList[index]
                obj.value=this.selectEntCountList[index].personCount
                objArry.push(obj)

  });
  console.log(objArry);
  this.echa(objArry,nameList,colorList)



}



    },
    echa(objArry,nameList,colorList){
      console.log('---->',objArry);
    this.$echarts.init(document.querySelector('.left-bottom-body')).dispose();
      let charta = this.$echarts.init(document.querySelector('.left-bottom-body'))
      const that = this

      var values = [110,56,50,30,30,50];
var sum = values[0] + values[1] + values[2] + values[3] + values[4] + values[5]; 
var legendData = nameList;
var colorList = colorList;


 var titletext = '';
let option = {
    // backgroundColor:'#000',
    title: {
        text: titletext,
        textAlign:'center',
        textStyle: {
            fontSize:18,
            color: '#fff'
        },
        left:'20%',
        top:'center'
    },
    tooltip: {
        trigger: 'item',
        borderColor: 'rgba(255,255,255,.3)',
        backgroundColor: 'rgba(13,5,30,.6)',
        borderWidth: 1,
        padding: 5,
        textStyle:{
            color:'#fff'
        }
    },
    legend: {
        type: "scroll",
        orient: 'vertical',
        right: '1%',
        align: 'auto',
        top: 'middle',
        itemGap:10,
        textStyle: {
            fontSize:12,
            color: '#fff'
        },
        data: legendData,
        formatter:function(name)
        {
            for(var i = 0;i < legendData.length;i++)
            {
                if (legendData[i] == name) {
                    return name  +"  "+"  "+ objArry[i].value +'    '+"  "+ that.selectEntCountList[i].proportion
                }
            }
        }
    },
    series: [{
        type: 'pie',
        z: 3,
        center: ['30%', '50%'],
        radius: ['50%', '65%'],
        clockwise: true,
        avoidLabelOverlap: true,
        hoverOffset: 15,
        itemStyle: {
            normal: {
                color: function(params) {
                    return colorList[params.dataIndex]
                }
            }
        },
        label: {
            show: false
        },
        data: objArry
    }, {
       
             label: {
                 normal: {
                     show: false
                 }
             },
             data: [{
                 value: 1,
                 name: '',
                 itemStyle: {
                     normal: {
                         borderWidth: 5,
                         borderColor: 'rgba(11,82,99,.5)'
                     }
                 }
             }]
    }]
};
      charta.setOption(option)
     window.addEventListener('resize', function () {
        charta.resize()
      });
    },
    // 获取人员年龄分布信息
    async ageDistribution(){
const data= await screenHttp.ageDistribution({
 projectId: this.projectId
})
if(data.data.code==200){
  console.log('人员年龄分布信息-----》',data);
  let dataObj=data.data.data
  console.log(dataObj);
let dataArry=[]
  
for ( let key in dataObj){
    let obj={value:'',name:''}

  if(key== 'cnt30'){
// 18-30
obj.name='18-30岁：'+dataObj[key]
obj.value=dataObj[key]
dataArry.push(obj)
console.log('++++++++++++++++++++',dataArry);

  }else if(key=='cnt40'){
//30-40
obj.name='30-40岁：'+dataObj[key]
obj.value=dataObj[key]
dataArry.push(obj)
console.log('++++++++++++++++++++',dataArry);
  }else if(key=='cnt50'){
    //40-50
    obj.name='40-50岁：'+dataObj[key]
    obj.value=dataObj[key]
dataArry.push(obj)
console.log('++++++++++++++++++++',dataArry);
    
  }else if(key=='cnt60'){
    // 50-60
    obj.name='50-60岁：'+dataObj[key]
    obj.value=dataObj[key]
dataArry.push(obj)
console.log('++++++++++++++++++++',dataArry);
  }
}
console.log('年龄数组---》',dataArry);
  this.rightBottomEcah(dataArry)
    }},
    echb(){
         this.$echarts.init(document.querySelector('.center-top-body-A')).dispose();
      let chartb = this.$echarts.init(document.querySelector('.center-top-body-A'))
    let XData = ['0', '1','2','3','4','5','7','9','10','11','12','13']
let valueData = {
   data1: [64,159,112,86,151,131,118,159,112,86,151,131,118],
   data2: [124,30,77,97,67,75,70,30,77,97,67,75,70],
   data3: [33,30,89,78,37,35,30,30,89,78,37,35,30]
}
 let option = {
  // backgroundColor:false,
    tooltip: {
        trigger: 'axis'
    },
    legend: {
        color: ["#F58080", "#47D8BE", "#F9A589"],
        right: '2%',
        top: '2%',
        textStyle:{
          color:'#ffffff'
        }
    },
    grid: {
        top: 'middle',
        left: '3%',
        right: '4%',
        bottom: '3%',
        height: '80%',
        containLabel: true
    },
    xAxis: {
        type: 'category',
        data: XData,
        axisLine: {
            lineStyle: {
                color: 'rgba(193, 207, 220, 1)',
            }
        },
        axisLabel: {
            textStyle: {
                color: "#FFFF"
            }
        },
    },
    yAxis: [{
            type: 'value',
            axisLabel: {                
                textStyle: {
                    color: "#FFFF"
                }}    ,
            axisLine: {
                show: false,
                lineStyle: {
                    color: '#cdd5e2'
                }
            },
            splitLine: {
                show: true,
                lineStyle: {
                    color: 'rgba(193, 207, 220, 1)',
                }
            },
        }
    ],
    series: [{
            name: '管理人员',
            type: 'line',
            data: valueData.data1,
            color: "rgba(112, 119, 242, 1)",
            symbol: "circle", //标记的图形为实心圆
            symbolSize: 9, //标记的大小
            lineStyle: {
                normal: {
                    width: 2,
                    color: {
                        type: 'linear',
                        colorStops: [{
                            offset: 0,
                            color: 'rgba(112, 119, 242, 1)' // 0% 处的颜色
                        }, {
                            offset: 0.4,
                            color: 'rgba(112, 119, 242, 1)' // 100% 处的颜色
                        }, {
                            offset: 1,
                            color: 'rgba(112, 119, 242, 1)' // 100% 处的颜色
                        }],
                        globalCoord: false // 缺省为 false
                    },
                    shadowColor: 'rgba(112, 119, 242, 0.5)',
                    shadowBlur: 10,
                    shadowOffsetY: 7
                }
            },
            itemStyle: {
                normal: {
                    color: 'rgba(112, 119, 242, 1)',
                }
            },
            emphasis: {
                // 鼠标hover上去的时候，拐点的颜色和样式
                itemStyle: {
                    color: 'rgba(129, 135, 244, 1)', //颜色
                    borderColor: '#fff', //图形的描边颜色
                    borderWidth: 2, // 描边的线宽
                    shadowBlur: 4, // 图形的阴影大小
                    shadowColor: 'rgba(129, 135, 244, 1)', // 图形的阴影颜色
                },
            },
            smooth: false
        },
        {
            name: '建筑工人',
            type: 'line',
            data: valueData.data2,
            symbol: "circle", //标记的图形为实心圆
            symbolSize: 9, //标记的大小
            lineStyle: {
                normal: {
                    width: 2,
                    color: {
                        type: 'linear',
                        colorStops: [{
                                offset: 0,
                                color: 'rgba(242, 121, 36, 1)' // 0% 处的颜色
                            },
                            {
                                offset: 0.4,
                                color: 'rgba(242, 121, 36, 1)' // 100% 处的颜色
                            }, {
                                offset: 1,
                                color: 'rgba(242, 121, 36, 1)' // 100% 处的颜色
                            }
                        ],
                        globalCoord: false // 缺省为 false
                    },
                    shadowColor: 'rgba(242, 121, 36, 0.5)',
                    shadowBlur: 10,
                    shadowOffsetY: 7
                }
            },
            itemStyle: {
                normal: {
                    color: 'rgba(242, 121, 36, 1)',
                }
            },
            emphasis: {
                // 鼠标hover上去的时候，拐点的颜色和样式
                itemStyle: {
                    color: 'rgba(242, 121, 36, 1)', //颜色
                    borderColor: '#fff', //图形的描边颜色
                    borderWidth: 2, // 描边的线宽
                    shadowBlur: 4, // 图形的阴影大小
                    shadowColor: 'rgba(242, 121, 36, 1)', // 图形的阴影颜色
                },
            },
            smooth: false
        },
         {
            name: '特种人员',
            type: 'line',
            data: valueData.data3,
            symbol: "circle", //标记的图形为实心圆
            symbolSize: 9, //标记的大小
            lineStyle: {
                normal: {
                    width: 2,
                    color: {
                        type: 'linear',
                        colorStops: [{
                                offset: 0,
                                color: 'red' // 0% 处的颜色
                            },
                            {
                                offset: 0.4,
                                color: 'red' // 100% 处的颜色
                            }, {
                                offset: 1,
                                color: 'red' // 100% 处的颜色
                            }
                        ],
                        globalCoord: false // 缺省为 false
                    },
                    shadowColor: 'rgba(242, 121, 36, 0.5)',
                    shadowBlur: 10,
                    shadowOffsetY: 7
                }
            },
            itemStyle: {
                normal: {
                    color: 'rgba(242, 121, 36, 1)',
                }
            },
            emphasis: {
                // 鼠标hover上去的时候，拐点的颜色和样式
                itemStyle: {
                    color: 'rgba(242, 121, 36, 1)', //颜色
                    borderColor: '#fff', //图形的描边颜色
                    borderWidth: 2, // 描边的线宽
                    shadowBlur: 4, // 图形的阴影大小
                    shadowColor: 'rgba(242, 121, 36, 1)', // 图形的阴影颜色
                },
            },
            smooth: false
        }
    ]
};
  chartb.setOption(option)
     window.addEventListener('resize', function () {
        chartb.resize()
      });
    },
    // 单位出勤人员统计
    async selectDayEntCount(){
    const data=  await screenHttp.selectDayEntCount({
      projectId: util.session.get('groupId'),
    })
    if(data.data.code==200){
console.log('单位出勤人员统计信息------>',data);
this.companyAttendance=data.data.data||[]
   setInterval(this.scroll3, 2000)

    }
    },
    // 人员年龄分布图表
    rightBottomEcah(dataArry){
       this.$echarts.init(document.querySelector('.rightBottomEcah')).dispose();
      let eche = this.$echarts.init(document.querySelector('.rightBottomEcah'))


      const list = dataArry
const total = list.reduce((a, b) => {
  return (typeof a === 'number' ? a : a.value) + b.value;
})
let series = [], startAngle = 90;
for (let i = 0; i < list.length; i++) {
  let item = list[i],
    radius = 80 - i * 5
  series.push({
    name: '',
    type: 'pie',
    startAngle,
    // clockwise: false,  //逆时针
    radius: [0, radius + '%'],
    center: ['35%', '50%'],
    itemStyle: {
      borderRadius: 2
    },
    label: {
      show: false,
    },
    data: [item, {
      value: total - item.value,
      name: '',
      itemStyle: {
        color: 'rgba(0,0,0,0)'
      },
      label: {
        show: false,
      }
    }]
  })
  startAngle -= parseInt(item.value / total * 360);
}

let option = {
  color:['#3C87ED','#2960AD','#154D98','#073286'],
  legend: {
    top: 'center',
    right: '5%',
         textStyle: {
            fontSize:12,
            color: '#fff'
        },
        formatter:[1,2,34,4]
  },
  series,
};
  eche.setOption(option)
     window.addEventListener('resize', function () {
        eche.resize()
      });

    }
    }
  }
</script>

<style>
.appBody {
  width: 100vw;
  /* height: 100vh; */
}
.leftBody {
  margin-left: 1.25vw;
  float: left;
  width: 24.7917vw;
  /* height: 10.4167vw; */
  /* background: pink; */
  margin-right: 3.125vw;
}
.centerBody {
  float: left;
  width: 41.6667vw;
  /* height: 10.4167vw; */

  margin-right: 3.125vw;
}
.rightBody {
  float: left;
  width: 24.7917vw;
  /* height: 10.4167vw; */
  /* background: pink; */
}
.left-top {
  width: 24.7917vw;
  height: 20.8333vw;
}
.left-top-title {
  font-family: PingFang SC;
  font-size: 0.9375vw;
  font-weight: normal;
  letter-spacing: 0em;

  color: #ffffff;

  text-align: left;
  width: 24.7917vw;
  height: 2.0833vw;
  line-height: 2.0833vw;
  background: linear-gradient(
    90deg,
    #0b213c 0%,
    #0a1b35 50%,
    rgba(11, 22, 47, 0.1) 100%,
    #0a1730 100%
  );
}
.left-top-body {
  padding-top: 1.25vw;
  width: 24.7917vw;
  height: 18.5417vw;
  background: rgba(0, 35, 102, 0.2);
}
.personnelTitle {
  float: left;
  width: 5.4167vw;
  height: 100%;
}
.personnel-right {
  position: relative;
  width: 6.875vw;
  height: 100%;
  float: right;
}
.num-Top{
  width: 100%;
  text-align: center;
  position: absolute;
  top:3.8083vw;
  font-family: PingFang SC;
font-size: 1.0417vw;
font-weight: normal;
letter-spacing: 0em;

color: #FFFFFF;
}
.num-Bottom{
   width: 100%;
  text-align: center;
  position: absolute;
  top:11.8083vw;
  font-family: PingFang SC;
font-size: 1.0417vw;
font-weight: normal;
letter-spacing: 0em;

color: #FFFFFF;
}
.personnelTitle-txt  {
  margin-bottom: 0.8854vw;
  font-family: PingFang SC;
font-size: .8333vw;
font-weight: normal;
letter-spacing: 0em;
color: #FFFFFF;
}
.titleClick {
  width: 5.4167vw;
  height: 2.0833vw;
  line-height: 2.0833vw;
  background: rgba(255, 255, 255, 0.01);
  box-sizing: border-box;
  border: 1px solid #01fffd;
font-family: PingFang SC;
font-size: .9375vw;
font-weight: 500;
letter-spacing: 0em;

color: #01FFFD;
  box-shadow: inset 0px 0px 0.8854vw 0px #4c71a6;
  margin-bottom: 0.4167vw !important;
}
.personnelCenter{
  position: relative;
  float: left;
  width: 12.3854vw;
  height: 100%;

/* background: url(''); */
}
.shuju{
  position: absolute;
  top: 3.083vw;
  width: 100%;
  text-align: center;
  position: absolute;
  left: .8083vw;
}
.centerNum{
font-family: PingFang SC;
font-size: 1.5625vw;
font-weight: 500;
letter-spacing: 0em;
color: #FFFFFF;
margin-bottom: .5208vw;
}
.centerNumTxt{
font-family: PingFang SC;
font-size: .7292vw;
font-weight: normal;
letter-spacing: 0em;
color: #FFFFFF;
}
.centerImg{
  width: 10.1563vw;
  height: 13.8542vw;
  top:2.625vw;
  position: absolute;
  left:1.9271vw;
}
.c-img{
  width: 6.875vw;
  height:6.875vw
}
.allTeamsCount{

  font-family: PingFang SC;
font-size: .7292vw;
font-weight: normal;
letter-spacing: 0em;

color: #01FFFD;
}
.left-body-bottom{
  margin-top: 2.975vw;
  width: 24.7917vw;
  height: 20.8333vw;
}
.center-top{
  width: 41.6667vw;
  height: 20.5333vw;
 background: rgba(0, 35, 102, 0.2);
 margin-bottom: 3.125vw;
}
.center-bottom{
  width: 41.6667vw;
  height: 20.8333vw;
 background: rgba(0, 35, 102, 0.2);
}
.center-top-title{
   font-family: PingFang SC;
  font-size: 0.9375vw;
  font-weight: normal;
  letter-spacing: 0em;

  color: #ffffff;

  text-align: left;
  width:41.6667vw;
  height: 2.0833vw;
  line-height: 2.0833vw;
  background: linear-gradient(
    90deg,
    #0b213c 0%,
    #0a1b35 50%,
    rgba(11, 22, 47, 0.1) 100%,
    #0a1730 100%)
}
.center-top-body{
  width: 41.6667vw;
  height: 18.5417vw;
}
.center-top-body-A{
  width: 41.6667vw;
  height: 17.8333vw;
}
.lfet-top-list{
    overflow: hidden;
  width: 100%;
  height: 100%;
  padding-left: .6771vw;
}
.lfet-top-list-body{
  font-family: PingFang SC;

font-weight: normal;
letter-spacing: 0em;
line-height: 3.125vw;
color: #FFFFFF;
  display: flex;
  border: 1px solid #3C87ED;
text-align: left;
  width: 23.4375vw;
  height: 3.125vw;
background: #132446;
box-sizing: border-box; 
border: 1px solid #3C87ED;
margin-bottom: .5208vw;

}
.lfet-top-list-body p{
font-size: .625vw;
}
.anim{
  margin-top: -3.6vw;
  transition: all 1s;
}
.animb{
  margin-top: -2.0vw;
  transition: all 1s;
}
.center-list-body{
  font-family: PingFang SC;
font-size: .7292vw;
font-weight: normal;
letter-spacing: 0em;

color: #FFFFFF;
  display: flex;
  margin-bottom: .625vw;
  width: 38.3333vw;
  height: 1.4583vw;
  background: linear-gradient(270deg, rgba(79,102,131,0.00) 0%, rgba(20,42,79,0.50) 52%, rgba(79,102,131,0.00) 100%);

box-sizing: border-box;
border: 1px solid ;
border-image: linear-gradient(270deg, rgba(140,180,231,0.00) 0%, rgba(97,163,246,0.50) 52%, rgba(140,180,231,0.00) )
}
.listTitle{
  display: flex;
  width: 100%;
  height: 3.125vw;
  line-height: 3.125vw;
  font-family: PingFang SC;
font-size: .7292vw;
font-weight: normal;
letter-spacing: 0em;

color: #B5B5B5;
}
.title-a{
  margin-left: 5.7292vw;
}
.title-b{
  margin-left: 4.6vw;
}
.title-c{
  margin-left: 4.6vw;
}
.title-d{
  margin-left: 4.6vw;
}
.list-body-title{
  overflow: hidden;
  text-align: left;
  white-space: nowrap;
  text-overflow: ellipsis;
  -o-text-overflow:ellipsis;
  width: 12.2083vw;
  height: 100%;
}
.list-body-A{
  text-align: center;
  width:2.0833vw;
  height: 100%;
  margin-left: 2.5vw;
}
.list-body-B{
    text-align: center;
 width:2.0833vw;
  height: 100%;
  margin-left: 6.6vw;
}
.list-body-C{
    text-align: center;
 width:2.0833vw;
  height: 100%;
  margin-left: 6.6vw;
}
.punchingCardImg{
  width: 3.125vw;
  height: 3.125vw;
  border: 1px solid #3C87ED;
  margin-right: .8333vw;
}
.punchingCardName{
  width: 2.063vw;
    overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  -o-text-overflow:ellipsis;
  margin-right: 1.5625vw;
}
.gangwei{
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
  -o-text-overflow:ellipsis;
  margin-right: 1.5625vw;
  width: 3.6458vw;
margin-right: 1.5625vw;
}
.border-Max{
  margin-top:.1042vw
}
.border-left{
  width:.3646vw;
  height:.1042vw;
  background:#518FE3;
  float:left;
  margin-right:.2083vw
}
.border-center{
  width:23.6458vw;
  height:.1042vw;
  background: linear-gradient(90deg, #11273F 0%, #608CCA 52%, #040D1F 100%);
  float:left;
    margin-right:.2083vw
}
.border-right{
  width:.3646vw;
  height:.1042vw;
  background:#518FE3;
  float:left;

}
.border-center-Max{
  margin-top:.1042vw
}
.border-center-left{
  width:.3646vw;
  height:.1042vw;
  background:#518FE3;
  float:left;
  margin-right:.2083vw
}
.border-center-center{
  width:40.5208vw;
  height:.1042vw;
  background: linear-gradient(90deg, #11273F 0%, #608CCA 52%, #040D1F 100%);
  float:left;
    margin-right:.2083vw
}
.border-center-right{
  width:.3646vw;
  height:.1042vw;
  background:#518FE3;
  float:left;

}
.leftTopIcon{
  width: 1.8115vw;
  height: 1.8115vw;
  margin-right: .6563vw;
}

</style>
<style scoped>
 @import '../../untils/screenTop.css'
</style>